// 2026-09-21 正式 iframe 通訊契約 v1。
export const DEFAULT_FRAME_SIZE = { width: 420, height: 560 }
export const FRAME_READY_TIMEOUT = 10000
export const SLOT_DEFINITIONS = [
  { routeName: 'home', slot: 'CRM首頁約診表左下方', page: 'CRM首頁', position: 'home' },
  { routeName: 'onlineReserve', slot: 'CRM線上約診頁面左下方', page: '線上約診', position: 'online-reserve' },
  { routeName: 'reschedule', slot: 'CRM改約頁面左下方', page: '改約', position: 'reschedule' },
  { routeName: 'review', slot: 'CRM評價總覽頁面左下方', page: '評價總覽', position: 'review' },
]

export function newSlotId() {
  const bytes = crypto.getRandomValues(new Uint8Array(16))
  bytes[6] = (bytes[6] & 15) | 64
  bytes[8] = (bytes[8] & 63) | 128
  const h = [...bytes].map(b => b.toString(16).padStart(2, '0')).join('')
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`
}

export function normalizeSlotConfig(body, slot) {
  if (!body || body.schema_version !== 2) throw new Error('廣告設定格式不符')
  const c = body.data
  if (c === null) return null
  const https = value => {
    try { const u = new URL(value); return u.protocol === 'https:' && !u.username && !u.password } catch { return false }
  }
  if (!c || typeof c.creative_id !== 'string' || !c.creative_id || c.channel !== 'crm' || c.slot !== slot ||
      !c.preview || c.preview.type !== 'image' || !https(c.preview.url) || !c.action ||
      !['link', 'iframe'].includes(c.action.type) || !https(c.action.url)) throw new Error('廣告設定內容不符')
  if (c.action.type === 'iframe' && (!c.survey || typeof c.survey.survey_id !== 'string' ||
      !c.survey.survey_id || !Number.isInteger(c.survey.survey_version) || c.survey.survey_version < 1)) throw new Error('缺少問卷識別')
  return c
}

export function createSlotEvent(config, identity, page, type, responseId = null) {
  return {
    schema_version: 2, event_id: newSlotId(), event_type: type, occurred_at: new Date().toISOString(),
    creative_id: config.creative_id, channel: 'crm', slot: config.slot, page,
    clinic_id: identity.clinic_id, id_type: identity.id_type, viewer: identity.viewer,
    response_id: responseId, meta: {},
  }
}

export function frameMessage(event, frameWindow, origin, responseId) {
  if (!frameWindow || event.source !== frameWindow || event.origin !== origin) return null
  const m = event.data
  if (!m || m.source !== 'dentco-ads' || m.version !== 1 || !responseId || m.response_id !== responseId ||
      !m.payload || typeof m.payload !== 'object' || Array.isArray(m.payload)) return null
  if (m.type === 'ready') return { type: m.type }
  if (m.type === 'request_collapse' && ['close', 'finish'].includes(m.payload.reason)) return { type: m.type }
  if (m.type === 'request_resize' && Number.isFinite(m.payload.height) && m.payload.height > 0) {
    return { type: m.type, height: Math.round(m.payload.height) }
  }
  return null
}

export function frameInit(config, identity, page, responseId, token) {
  return { source: 'dentco-crm', version: 1, type: 'init', response_id: responseId, payload: {
    context_token: token, creative_id: config.creative_id, channel: config.channel, slot: config.slot, page,
    ...identity, survey_id: config.survey.survey_id, survey_version: config.survey.survey_version,
  } }
}

export function frameUrl(url, origin, responseId) {
  const result = new URL(url)
  result.searchParams.set('parent_origin', origin)
  result.searchParams.set('response_id', responseId)
  return result.href
}

export function tokenRefreshDelay(token, now = Date.now()) {
  try {
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')))
    if (!Number.isFinite(payload.exp)) return null
    return Math.max(1000, Math.min(14 * 60 * 1000, payload.exp * 1000 - now - 60000))
  } catch { return null }
}

export function clampFrameSize(size, viewport) {
  return {
    width: Math.max(1, Math.min(420, viewport.width - 32)),
    height: Math.max(1, Math.min(viewport.height - 112, Math.max(360, Math.min(640, size.height)))),
  }
}
